<template>
  <transition name="fade">
    <div class="submit-container">
      <div class="upload-form">
        <Icon class="close-btn" type="md-close" :size="30" color="#666" @click="$emit('close')"></Icon>
        <div class="form-container">
          <div class="title">上传作品</div>
          <div class="tips">
            参赛作品不支持删除<!--,大赛进行中上传后的作品如需修改,可在【我的笔记】点击"编辑"进行修改-->
          </div>
          <div class="form">
            <Form ref="up_form" label-position="top" :model="form">
              <FormItem
                label="作品名称："
                prop="title"
                required
                style="max-width: 750px"
              >
                <Input
                  v-model="form.title"
                  placeholder="请输入作品名称"
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                />
              </FormItem>
              <FormItem prop="image_list" label="作品图片(可多张)：">
                <template slot="label">
                  <div class="img-list-title">作品图片(可多张):<span>务必上传参赛作品的设计效果图！款式结构图、工艺细节图等可自行决定是否提交。</span></div>
                </template>
                <div class="upload-list">
                  <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    multiple
                    :before-upload="(file) => beforeUpload(file, 'img_list')"
                    :on-success="
                      (response, file, fileList) =>
                        handleSuccess(response, file, fileList, 'img_list')
                    "
                    :show-upload-list="false"
                    :format="['jpg', 'jpeg', 'png', 'gif', 'webp']"
                    accept=".jpg,.jpeg,.png,.gif,.webp"
                    :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  >
                    <template>
                      <div class="upload-btn">
                        <img
                          src="../../../assets/images/icon-add-match-upload.png"
                        />
                        <div class="btn-text">上传参赛作品</div>
                        <div class="btn-desc">
                          <p>支持jpg/gif/png格式RGB模式</p>
                          <p>不超过20M</p>
                        </div>
                      </div>
                    </template>
                  </Upload>
                  <div
                    class="img-item"
                    v-for="(item, index) in form.image_list"
                    :key="index"
                  >
                    <img v-viewer :src="item" />
                    <img
                      v-if="!(form.status != 3 && form.status != 5 && form.uuid)"
                      @click.stop="removeImg(index)"
                      src="../../../assets/images/icon-close@2x.png"
                      alt=""
                      class="remove"
                    />
                  </div>
                </div>
              </FormItem>
              <FormItem
                prop="content"
                label="作品说明"
                required
                style="max-width: 750px"
              >
                <textarea
                  v-model="form.content"
                  :rows="4"
                  placeholder="请输入作品说明"
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                ></textarea>
              </FormItem>
              <FormItem
                v-for="(item, index) in form.custom_field"
                :key="index"
                :label="item.name"
                :prop="'custom_field.' + index + '.value'"
                :rules="{
                  required: item.is_required,
                  message: item.name + '不能为空',
                  trigger: 'blur',
                }"
              >
                <Input
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  v-model="item.value"
                  :placeholder="'请输入' + item.name"
                  v-if="item.type == 'text'"
                  style="max-width: 750px"
                />
                <Date-picker
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  @on-change="handleChange($event, index)"
                  format="yyyy-MM-dd"
                  type="date"
                  :placeholder="'请选择' + item.name"
                  v-model="item.value"
                  v-if="item.type == 'date'"
                ></Date-picker>
                <Date-picker
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  @on-change="handleChange($event, index)"
                  format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  :placeholder="'请选择' + item.name"
                  v-model="item.value"
                  v-if="item.type == 'time'"
                ></Date-picker>

                <Select
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  v-model="item.value"
                  :placeholder="'请选择' + item.name"
                  v-if="item.type == 'select'"
                  style="max-width: 750px"
                >
                  <Option
                    :value="i.name"
                    v-for="(i, y) in item.options"
                    :key="y"
                    >{{ i.name }}</Option
                  >
                </Select>
                <Checkbox-group
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  v-model="item.value"
                  v-if="item.type == 'checkbox'"
                >
                  <Checkbox
                    :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                    :label="i.name"
                    v-for="(i, y) in item.options"
                    :key="y"
                    >{{ i.name }}</Checkbox
                  >
                </Checkbox-group>
                <Upload
                  action=""
                  :show-upload-list="true"
                  :before-upload="(file) => beforeUpload(file, index)"
                  accept=".jpg,.jpeg,.png,.gif,.webp"
                  :format="['jpg', 'jpeg', 'png', 'gif', 'webp']"
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  v-if="item.type == 'img'"
                >
                  <div
                    class="sign-img-box"
                    style="width: 80px; height: 80px; border: 1px dashed #ddd"
                  >
                    <img
                      class="img"
                      v-if="item.value"
                      :src="item.value"
                      style="width: 80px; height: 80px"
                    />
                    <img
                      v-else
                      src="../../../assets/images/icon-add-match-upload.png"
                      class="icon"
                    />
                  </div>
                </Upload>
                <Upload
                  :disabled="!!(form.status != 3 && form.status != 5 && form.uuid)"
                  action=""
                  :before-upload="(file) => beforeUpload(file, index)"
                  v-if="item.type == 'file'"
                >
                  <Button>上传文件</Button>
                  <a style="margin-left: 10px" v-if="item.value">{{
                    item.fileName
                  }}</a>
                </Upload>
              </FormItem>
              <FormItem v-if="!form.status || form.status == 3 || form.status == 5">
                <Checkbox v-model="form.is_agree">
                  <span>我已同意</span>
                  <span
                    style="color: #fa3d5a"
                    @click.stop="toCommitment(item.id)"
                    v-for="(item, index) in uploadCommitments"
                    :key="index"
                    >《{{ item.title }}》</span
                  >
                  <span> 等所有条款</span>
                </Checkbox>
              </FormItem>
            </Form>
            <div class="">说明:作品名称+设计效果图+作品说明，以上3项齐全视为一组有效的稿件。欢迎参赛选手上传设计灵感、款式结构图、工艺细节图等更多详尽材料。</div>
            <Button
              v-if="!form.status || form.status == 3 || form.status == 5"
              @click="onPostsSubmit"
              class="submit"
              >确认上传</Button
            >
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { MatchPostsUpload, MatchSignInCheck } from "@/api/social";
import { uploadFileToOSS } from '@/utils/oss';
export default {
  name: "SubmitWorks",
  props: {
    matchUUID: {
      type: String,
      default: "",
    },
    formData:{
        type:Object,
        default:()=>{}
    },
    detail:{
        type:Object,
        default:()=>{}
    }
  },
  data() {
    return {
        form:{},
        upload_url: process.uniEnv.BASE_API + "/util/upload-image",
    };
  },
  computed:{
    signCommitments() {
      if(!this.detail.commitments) {
        return []
      }
      return this.detail.commitments.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    signCustomField() {
      if(!this.detail.custom_field) {
        return []
      }
       return this.detail.custom_field.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    uploadCommitments() {
      if(!this.detail.commitments) {
        return []
      }
       return this.detail.commitments.filter((i)=>{
        return i.use_type== 'upload'
      })
    },
  },
  mounted() {
    this.form = this.formData;
  },
  methods: {
    removeImg(index){
      this.form.image_list.splice(index,1)
    },
    toCommitment(id) {
        const uri = `${window.location.origin}/commitment?id=${id}`;
        window.open(uri, "_blank");
    },
    beforeUpload(file, index) {
      this.uploadSectionFile(file, index)
      return false
    },
    async uploadSectionFile(file, index) {
        const url = await uploadFileToOSS(file, 'template')
        if(index === 'img_list'){
          this.form.image_list.push(url);
        }else{
          this.form.custom_field[index].value = url
          this.form.custom_field[index].fileName = file.name
        }
    },
    async onPostsSubmit(){
        try{
          // console.log('this.form',this.form);
            if(this.form.uuid && this.form.status == 2){
              this.$layer.msg("当前作品已经审核完成,无法再次更改")
              return;
            }
          // return;
            const {is_agree,title,image_list,content} = this.form;
            if(!is_agree){
                this.$layer.msg('请先同意规则');
                return;
            }
            if(!title || !image_list.length || !content){
                this.$layer.msg("请填写完整信息");
                return;
            }
            let msg = ''
            this.form.custom_field.forEach((i)=>{
                if(i.is_required && !i.value) {
                    msg = i.name + '必填'
                }
            })
            if(msg) {
                this.$layer.msg(msg);
                return;
            }
            const param = this.form;
            param.match_uuid = this.matchUUID;
            console.log('param===',param);
            // const {data} = 
            await MatchPostsUpload(param); 
            console.log('image_list',image_list);
            this.$emit('confirm',{image_list});
            // console.log('data',data);
            // this.$layer.msg('上传成功,请耐心等待审核');
            // this.$refs['up_form'].resetFields();
            // this.form.image_list = [];
            // window.location.reload();
            // this.$router.push({name:'Posts',params:{uuid:data.post_uuid}});
        }catch(e){
            console.log('e-upload-e',e);
            this.$layer.msg(e.msg);
        }
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.form.image_list.length;
      if (length > 18) {
        this.$layer.msg("最多上传18张图片");
        return;
      }
      if (field === "img_list") {
        this.form.image_list.push(response.data.url);
      }
    },
    async onUploadClick() {
        try{
          if(!this.canUpload){
            this.$layer.msg("已过报名时间或比赛已结束");
            return;
          }
            const {data} = await MatchSignInCheck({uuid:this.matchUUID});
            console.log('data',data);
            if(!data.is_signin){
                this.$layer.msg('请先报名比赛');
                return;
            }
            const {is_upload} = this.detail;
        //     title: "",
        // image_list: [],
        // content: "",
        // is_agree:false,
        // custom_field:[]
            // const {uuid,status,content,cover,image_list,custom_field,title} = is_upload;
            console.log('is_upload',is_upload);
            if(is_upload.uuid){
              if(is_upload.length>0 || is_upload.uuid){
                await this.$set(this,'form',is_upload);
              }
              await localStorage.setItem('match_upload',JSON.stringify({...is_upload,match_uuid:this.matchUUID}));
              this.$router.push({name:'WorksDetail'});
              return;
            }
            this.show_upload = true;
            this.menu_type = 'match_introduction';
        }catch(e){
            console.log('e-sign-in-e',e);
            this.$layer.msg(e.msg);
        }
    },
  },
};
</script>
<style lang="scss" scoped>
.submit-container {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 119;
  display: flex;
  align-items: center;
  justify-content: center;
  .upload-form {
    box-sizing: border-box;
    border-radius: 20px;
    // box-shadow: 0px 0px 15px 0px #e0e0e0;
    width: 100%;
    max-width: 1229px;
    max-height:800px;
    // overflow-y:auto;
    overflow:hidden;
    background:#fff;
    position:relative;
    .close-btn{
        position:absolute;
        top:10px;
        right:10px;
        cursor: pointer;
    }
    .form-container {
      padding: 30px 60px 0 60px;
      
      .title {
        font-weight: bold;
        color: #1a1a1a;
        font-size: 24px;
        width: 100%;
      }
      .tips {
        color: #808080;
        font-size: 12px;
        padding-bottom: 22px;
        border-bottom: 1px solid #ebebeb;
      }
      .form {
        padding-top: 35px;
        width: 100%;
        max-height:700px;
        overflow-y:auto;
        ::v-deep .ivu-form-item-label {
          font-size: 14px;
          color: #1a1a1a;
        }
        .img-list-title{
          font-size:14px;
          color:#1a1a1a;
          span{
            color:red;
          }
          &::before{
            content:"*";
            color:red;
          }
        }
        .upload-list {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          column-gap: 20px;

          .upload-btn {
            background: #fafafa;
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            width: 255px;
            height: 255px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: column;
            margin-bottom: 20px;
            img {
              width: 32px;
              height: 32px;
              background: transparent;
            }
            .btn-text {
              color: #4d4f52;
              font-size: 14px;
              width: 100%;
              text-align: center;
            }
            .btn-desc {
              width: 100%;
              font-size: 12px;
              color: #b3b3b3;
              text-align: center;
              p {
                line-height: 1.5;
              }
            }
          }
          .img-item {
            margin-bottom: 20px;
            width: 255px;
            height: 255px;
            background: #808080;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            .remove {
              position: absolute;
              top: 0;
              right: 0;
              width: 30px;
              height: 30px;
            }
          }
        }

        textarea {
          width: 100%;
          outline: none;
          border: 1px solid #c0c4cc;
          border-radius: 5px;
          padding-left: 5px;
        }

        .submit {
          background: #ff5967;
          border-radius: 5px;
          color: #ffffff;
          width: 160px;
          height: 45px;
          margin-bottom: 100px;
          margin-top:10px;
          &:hover {
            border: none;
          }
        }
      }
    }
  }
}

::v-deep .ivu-form-item{
  margin-bottom:10px !important;
}
</style>
